import styled from 'styled-components/macro';
import {useEffect} from "react";
import {useActions} from "../../store";
import useHost from "../../utils/host";
import {useGoogleAdsEnabled} from "../../store/hooks";

const GoogleAd = styled(({adId, className, children}) => {

    const isScoredCo = useHost() === "scored.co";

    const actions = useActions();
    const googleAdsEnabled = useGoogleAdsEnabled();
    useEffect(() => {
        if (isScoredCo && !googleAdsEnabled) {
            actions.googleAdsEnabledChanged(true);
        }
    }, []);

    useEffect(() => {
        if (typeof advally !== 'undefined' && typeof advally.removeUnit === 'function' && typeof advally.scanNew === 'function') {
            advally.removeUnit(adId).scanNew();
        } else if (typeof advally !== 'undefined' && typeof advally.scanNew === 'function') {
            advally.scanNew();
        }
    }, [])

    return (
        <div className={className}>
            {children}
        </div>
    );
})`
display: flex;
justify-content: center;`;

export default GoogleAd;
